/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Obsługiwane przez Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Obsługiwane przez AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Generowana treść zależy od Twoich uprawnień, a jej jakość może być zmienna.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Jakość treści może być zmienna',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informacja',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Uwzględnij wiedzę z bieżącej strony',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Wstecz',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Anuluj',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Anuluj',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Anuluj',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Niewłaściwa reakcja',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Wysłano opinię',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Właściwa reakcja',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Kontynuuj od ostatniej odpowiedzi',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopiuj',
  'fabric.editor.ai.config.item.action.responseCopied': 'Skopiowano!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Skopiowano do schowka',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Spróbuj ponownie',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Wystąpiły problemy podczas wstawiania odpowiedzi. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Nie można pobrać odpowiedzi. Twoja podpowiedź lub odpowiedź przekroczyła limit tego żądania. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience.apiError': 'Nie można uzyskać odpowiedzi. Spróbuj ponownie.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Treść jest za krótka, aby ją podsumować. Dodaj więcej i spróbuj ponownie.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Generowanie',
  'fabric.editor.ai.experience.previewScreenLabel': 'Podgląd',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Poproś agenta o napisanie czegoś lub wybierz opcję poniżej',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Wstecz',
  'fabric.editor.ai.screens.discard.discardLabel': 'Odrzuć',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Ostrzeżenie',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Błąd',
  'fabric.editor.ai.screens.error.cancelLabel': 'Anuluj',
  'fabric.editor.ai.screens.error.retryLabel': 'Spróbuj ponownie',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Dynamiczne aktualizowane treści:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Ikona generowania',
  'fabric.editor.ai.screens.preview.betaLabel': 'Wersja beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Anuluj',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Przekaż AI, co ma zrobić',
  'fabric.editor.ai.screens.preview.discardLabel': 'Odrzuć',
  'fabric.editor.ai.screens.preview.disclaimer': 'Jakość informacji może się różnić.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Dowiedz się, dlaczego',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Wyczyść',
  'fabric.editor.ai.screens.preview.header.edit': 'Edytuj podpowiedź',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Edytuj',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Zapytaj {agentName} o następne kroki',
  'fabric.editor.ai.screens.preview.refineButton': 'Popraw',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Popraw',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Prześlij',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Wyślij do AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} — wybrano',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Usuń',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Sugestie',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Asystent pisania',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Skorzystaj z pomocy Atlassian Intelligence podczas pisania',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Napisz',
  'fabric.editor.ai.shared.betaLabel': 'Wersja beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOWOŚĆ',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Zapytaj AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Zapytaj agenta',
};
